
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/truck-drivers-news/[id]",
      function () {
        return require("private-next-pages/truck-drivers-news/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/truck-drivers-news/[id]"])
      });
    }
  